import React, { Component } from 'react'
import CustomChatbot from "./chatbot/CustomChatbot";

class Footer extends Component {
    render() {
        let guj ="http://stocksgems.in";
        return (
            <footer className="main-footer">
               <CustomChatbot eventHandler={this.clickEventHandler} />    
            <div className="pull-right hidden-xs">
            <b>Version</b> 1.0.0
            </div>
                <strong>Designed & Developed By  <a href={guj}>Dilip Gauswami </a>.</strong>Gandhinagar(Gujarat) 
            </footer>      
               
        )
    }
}

export default Footer
